export enum EDocumentType {
  LAB_RESULT = 'LAB_RESULT',
  IMAGE_RESULT = 'IMAGE_RESULT',
  ENCOUNTER_SUMMARY = 'ENCOUNTER_SUMMARY',
  SNAPSHOT = 'SNAPSHOT',
  OTHER = 'OTHER',
}
